/**
 * Hook for fetching SSO provider availability from the server.
 */

import { resolveApiBaseUrl } from '@polygraf/shared'
import { useQuery } from '@tanstack/react-query'

interface SsoConfig {
	providers: {
		google: boolean
		microsoft: boolean
		muni: boolean
		eduid: boolean
		apple: boolean
		seznam: boolean
		livekit: boolean
	}
}

const API_URL = resolveApiBaseUrl(import.meta.env.VITE_API_URL)

export function useSsoConfig() {
	const { data, isLoading, error } = useQuery<SsoConfig>({
		queryKey: ['sso-config'],
		queryFn: async () => {
			const res = await fetch(`${API_URL}/api/auth/config`)
			if (!res.ok) throw new Error(`HTTP ${res.status}`)
			return res.json()
		},
		staleTime: Infinity,
		retry: 1,
	})

	return {
		googleEnabled: data?.providers.google ?? false,
		microsoftEnabled: data?.providers.microsoft ?? false,
		muniEnabled: data?.providers.muni ?? false,
		eduidEnabled: data?.providers.eduid ?? false,
		appleEnabled: data?.providers.apple ?? false,
		seznamEnabled: data?.providers.seznam ?? false,
		livekitEnabled: data?.providers.livekit ?? false,
		isLoading,
		error: error ?? null,
	}
}
